import React from 'react';
import styled from 'styled-components';

const StyledSocial = styled.div`
  position: fixed;
  bottom: 20px;
  left: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media (max-width: 900px) {
    display: none;
  }

  a {
    margin-bottom: 20px;
  }
`;

const Social = () => {
  return (
    <StyledSocial>
      <a href="https://github.com/nazariiko" target="_blank" rel="noreferrer">
        <svg
          width="25"
          height="25"
          viewBox="0 0 37 37"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path
            d="M18.5 3.46362C14.8392 3.46377 11.298 4.76651 8.50991 7.13872C5.72181 9.51093 3.86877 12.7978 3.28237 16.4113C2.69597 20.0247 3.41447 23.7289 5.30931 26.8611C7.20414 29.9933 10.1517 32.349 13.6245 33.5068C14.3953 33.6418 14.6844 33.1793 14.6844 32.7745C14.6844 32.4084 14.6651 31.1943 14.6651 29.9032C10.7916 30.6162 9.78954 28.959 9.48121 28.0918C9.13908 27.2484 8.59672 26.501 7.901 25.9141C7.36142 25.6251 6.59059 24.9121 7.88172 24.8928C8.37472 24.9463 8.84757 25.1179 9.26018 25.3929C9.6728 25.668 10.013 26.0385 10.252 26.473C10.4629 26.8518 10.7464 27.1852 11.0864 27.4542C11.4263 27.7233 11.816 27.9226 12.2331 28.0407C12.6502 28.1589 13.0866 28.1936 13.5171 28.1428C13.9476 28.092 14.3639 27.9568 14.7421 27.7449C14.8089 26.9611 15.1582 26.2283 15.725 25.6829C12.2948 25.2975 8.71038 23.9678 8.71038 18.071C8.68871 16.5388 9.2541 15.0563 10.2906 13.9277C9.81927 12.5961 9.87442 11.1347 10.4448 9.84231C10.4448 9.84231 11.7359 9.43761 14.6843 11.4225C17.2069 10.7287 19.8701 10.7287 22.3927 11.4225C25.3411 9.41836 26.6323 9.84231 26.6323 9.84231C27.2027 11.1347 27.2578 12.5961 26.7864 13.9277C27.826 15.0544 28.3919 16.5381 28.3666 18.071C28.3666 23.9871 24.763 25.2975 21.3328 25.6829C21.7007 26.0558 21.9841 26.5036 22.1636 26.9957C22.3432 27.4878 22.4147 28.0128 22.3734 28.535C22.3734 30.597 22.3541 32.2543 22.3541 32.7746C22.3541 33.1793 22.6432 33.6611 23.414 33.5069C26.8807 32.3396 29.8198 29.9784 31.7065 26.8446C33.5933 23.7108 34.3049 20.0085 33.7145 16.3986C33.124 12.7886 31.2699 9.50599 28.483 7.13666C25.6961 4.76733 22.1579 3.46553 18.5 3.46362Z"
            fill="#CEC2FF"
          />
        </svg>
      </a>
      <a href="https://www.instagram.com/nazarii.kovalenko" target="_blank" rel="noreferrer">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30" width="25px" height="25px">
          <g id="surface1476328">
            <path
              fill="#CEC2FF"
              d="M 10 3 C 6.140625 3 3 6.140625 3 10 L 3 20 C 3 23.859375 6.140625 27 10 27 L 20 27 C 23.859375 27 27 23.859375 27 20 L 27 10 C 27 6.140625 23.859375 3 20 3 Z M 22 7 C 22.550781 7 23 7.449219 23 8 C 23 8.550781 22.550781 9 22 9 C 21.449219 9 21 8.550781 21 8 C 21 7.449219 21.449219 7 22 7 Z M 15 9 C 18.308594 9 21 11.691406 21 15 C 21 18.308594 18.308594 21 15 21 C 11.691406 21 9 18.308594 9 15 C 9 11.691406 11.691406 9 15 9 Z M 15 11 C 12.789062 11 11 12.789062 11 15 C 11 17.210938 12.789062 19 15 19 C 17.210938 19 19 17.210938 19 15 C 19 12.789062 17.210938 11 15 11 Z M 15 11 "
            />
          </g>
        </svg>
      </a>
      <a href="https://t.me/nazariikovalenko" target="_blank" rel="noreferrer">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" width="25px" height="25px">
          <g id="surface1477357">
            <path
              fill="#CEC2FF"
              d="M 46.136719 6.550781 C 45.386719 5.914062 44.210938 5.824219 42.992188 6.3125 L 42.988281 6.3125 C 41.707031 6.828125 6.726562 21.832031 5.304688 22.445312 C 5.046875 22.535156 2.78125 23.378906 3.015625 25.257812 C 3.222656 26.953125 5.042969 27.65625 5.265625 27.738281 L 14.15625 30.78125 C 14.746094 32.746094 16.921875 39.992188 17.402344 41.539062 C 17.703125 42.503906 18.191406 43.773438 19.050781 44.035156 C 19.800781 44.324219 20.550781 44.058594 21.03125 43.679688 L 26.46875 38.636719 L 35.246094 45.480469 L 35.457031 45.605469 C 36.050781 45.871094 36.621094 46.003906 37.167969 46.003906 C 37.589844 46.003906 37.992188 45.921875 38.378906 45.765625 C 39.695312 45.226562 40.21875 43.972656 40.273438 43.828125 L 46.832031 9.753906 C 47.230469 7.933594 46.675781 7.007812 46.136719 6.550781 Z M 22 32 L 19 40 L 16 30 L 39 13 Z M 22 32 "
            />
          </g>
        </svg>
      </a>
    </StyledSocial>
  );
};

export default React.memo(Social);
